import { useState } from 'react';
import { useNavigate } from 'react-router';

export function SearchBox({ initial = '' }: { initial?: string }) {
  const [q, setQ] = useState(initial);
  const navigate = useNavigate();
  const submit = (e: { preventDefault(): void }) => {
    e.preventDefault();
    const term = q.trim();
    if (term.length >= 2) navigate(`/search?q=${encodeURIComponent(term)}`);
  };
  return (
    <form className="search-form" role="search" onSubmit={submit}>
      <input
        type="search"
        name="q"
        aria-label="Search"
        placeholder="Search quests, items, NPCs..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
        maxLength={100}
      />
      <button type="submit">Search</button>
    </form>
  );
}
